import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// Register Method
export const postFakeRegister = (data: any) =>
  api.create(url.POST_FAKE_REGISTER, data);

// postForgetPwd
export const postFakeForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data: any) =>
  api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data: any) =>
  api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);

// Register Method
export const postJwtRegister = (url: any, data: any) => {
  return api.create(url, data).catch((err: any) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// postForgetPwd
export const postJwtForgetPwd = (data: any) =>
  api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// Invoice Methods
export const getInvoiceList = () => api.get(url.GET_INVOICE_LIST, null);
export const addInvoiceList = (data: any) =>
  api.create(url.ADD_INVOICE_LIST, data);
export const updateInvoiceList = (data: any) =>
  api.update(url.UPDATE_INVOICE_LIST, data);
export const deleteInvoiceList = (invoicelist: any) =>
  api.delete(url.DELETE_INVOICE_LIST, { headers: { invoicelist } });














